import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import AOS from "aos";
import "aos/dist/aos.css";
import './MainCSS.css'
import { BsFillArchiveFill, BsFillGrid3X3GapFill, BsPeopleFill, BsFillBellFill } from 'react-icons/bs';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line } from 'recharts';

const Dashboard = () => {

  const navigate = useNavigate();

  useEffect(() => { 

      //---------------------------------Disabled back button-------------------------------
      window.history.pushState(null, null, window.location.href);
  
      const handleBackButton = (event) => {
        event.preventDefault();
        window.history.forward();
      };
  
      window.addEventListener('popstate', handleBackButton);
  
      return () => {
        window.removeEventListener('popstate', handleBackButton);
      };
    }, [navigate]);

  useEffect(() => {
      // Initialize AOS
      AOS.init({
          disable: "phone",
          duration: 700,
          easing: "ease-out-cubic",
      });

      // Check if isLoggedIn is null or blank
      const userData = sessionStorage.getItem('authToken');
      if (!userData || userData.trim() === '') {
          navigate('/');
          sessionStorage.clear();
      }
  }, [navigate]);

  const data = [
    { name: 'Page A', uv: 4000, pv: 2400, amt: 2400 },
    { name: 'Page B', uv: 3000, pv: 1398, amt: 2210 },
    { name: 'Page C', uv: 2000, pv: 9800, amt: 2290 },
    { name: 'Page D', uv: 2780, pv: 3908, amt: 2000 },
    { name: 'Page E', uv: 1890, pv: 4800, amt: 2181 },
    { name: 'Page F', uv: 2390, pv: 3800, amt: 2500 },
    { name: 'Page G', uv: 3490, pv: 4300, amt: 2100 },
];

    return (
        <div className="row m-0">
         
            <div className="row m-0">
              
                    <div className="col-12 col-md-6 col-lg-3 py-2">
                      <div className='shadow-lg p-4 rounded flex flex-col items-center text-center' style={{backgroundColor:"#e6f3fd",color:"#000",fontWeight:"bold"}}>
                      <div className='row m-0 p-1'>
                      <div className='col-4 rounded' style={{backgroundColor:"#fc9006",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff"}}>
                         <BsFillArchiveFill style={{fontSize:"18px",marginTop:"-2px"}}/>
                      </div>
                      <div className='col-8'>
                        <div className="text-xl font-bold mb-2">PRODUCTS</div>
                        <div className="text-4xl font-semibold">300</div>
                        </div>
                      </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3 py-2">
                      <div className='shadow-lg p-4 rounded flex flex-col items-center text-center' style={{backgroundColor:"#e6f3fd",color:"#000",fontWeight:"bold"}}>
                      <div className='row m-0 p-1'>
                      <div className='col-4 rounded' style={{backgroundColor:"#4ba64f",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff"}}>
                         <BsFillGrid3X3GapFill style={{fontSize:"18px",marginTop:"-2px"}}/>
                      </div>
                      <div className='col-8'>
                        <div className="text-xl font-bold mb-2">CATEGORIES</div>
                        <div className="text-4xl font-semibold">12</div>
                        </div>
                      </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3 py-2">
                      <div className='shadow-lg p-4 rounded flex flex-col items-center text-center' style={{backgroundColor:"#e6f3fd",color:"#000",fontWeight:"bold"}}>
                      <div className='row m-0 p-1'>
                      <div className='col-4 rounded' style={{backgroundColor:"#e63d39",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff"}}>
                         <BsPeopleFill style={{fontSize:"18px",marginTop:"-2px"}}/>
                      </div>
                      <div className='col-8'>
                        <div className="text-xl font-bold mb-2">CUSTOMERS</div>
                        <div className="text-4xl font-semibold">33</div>
                        </div>
                      </div>
                      </div>
                    </div>

                    <div className="col-12 col-md-6 col-lg-3 py-2">
                      <div className='shadow-lg p-4 rounded flex flex-col items-center text-center' style={{backgroundColor:"#e6f3fd",color:"#000",fontWeight:"bold"}}>
                      <div className='row m-0 p-1'>
                      <div className='col-4 rounded' style={{backgroundColor:"#12b8cd",display:"flex",alignItems:"center",justifyContent:"center",color:"#fff"}}>
                         <BsFillBellFill style={{fontSize:"18px",marginTop:"-2px"}}/>
                      </div>
                      <div className='col-8'>
                        <div className="text-xl font-bold mb-2">ALERTS</div>
                        <div className="text-4xl font-semibold">42</div>
                        </div>
                      </div>
                      </div>
                    </div>
                 

                    {/* <div className="col-3 py-2">
                      <div className='shadow-lg p-4 rounded flex flex-col items-center text-center' style={{backgroundColor:"#4ba64f",color:"#fff",fontWeight:"bold"}}>
                        <div className="text-xl font-bold mb-2">CATEGORIES  &nbsp;&nbsp; <BsFillGrid3X3GapFill style={{fontSize:"18px",marginTop:"-2px"}}/></div>
                        <div className="text-4xl font-semibold">12</div>
                      </div>
                    </div>

                    <div className="col-3 py-2">
                      <div className='shadow-lg p-4 rounded flex flex-col items-center text-center' style={{backgroundColor:"#e63d39",color:"#fff",fontWeight:"bold"}}>
                        <div className="text-xl font-bold mb-2">CUSTOMERS  &nbsp;&nbsp; <BsPeopleFill style={{fontSize:"18px",marginTop:"-2px"}}/></div>
                        <div className="text-4xl font-semibold">33</div>
                      </div>
                    </div>

                    <div className="col-3 py-2">
                      <div className='shadow-lg p-4 rounded flex flex-col items-center text-center' style={{backgroundColor:"#12b8cd",color:"#fff",fontWeight:"bold"}}>
                        <div className="text-xl font-bold mb-2">ALERTS  &nbsp;&nbsp; <BsFillBellFill style={{fontSize:"18px",marginTop:"-2px"}}/></div>
                        <div className="text-4xl font-semibold">42</div>
                      </div>
                    </div> */}
                
            </div>

            <div className="row m-0 mb-5 mt-2">
                <div className="col-12 col-lg-6">
                    <div className='bg-white shadow-lg p-4 rounded'>
                      <h4 className="text-lg font-semibold mb-4">Bar Chart</h4>
                      <ResponsiveContainer width="100%" height={300}>
                          <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis dataKey="name" />
                              <YAxis />
                              <Tooltip />
                              <Legend />
                              <Bar dataKey="pv" fill="#8884d8" />
                              <Bar dataKey="uv" fill="#82ca9d" />
                          </BarChart>
                      </ResponsiveContainer>
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <div className='bg-white shadow-lg p-4 rounded'>
                      <h4 className="text-lg font-semibold mb-4">Line Chart</h4>
                      <ResponsiveContainer width="100%" height={300}>
                          <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                              <CartesianGrid strokeDasharray="3 3" />
                              <XAxis dataKey="name" />
                              <YAxis />
                              <Tooltip />
                              <Legend />
                              <Line type="monotone" dataKey="pv" stroke="#8884d8" activeDot={{ r: 8 }} />
                              <Line type="monotone" dataKey="uv" stroke="#82ca9d" />
                          </LineChart>
                      </ResponsiveContainer>
                    </div>
                </div>
            </div>

            
        </div>
    );
};

export default Dashboard;
